import isEmpty from 'lodash/isEmpty';

export const TeaserBlockDataAdapter = ({
  block,
  data,
  id,
  onChangeBlock,
  value,
}) => {
  let dataSaved = {
    ...data,
    [id]: value,
  };

  if (id === 'href' && !isEmpty(value) && !data.title && !data.description) {
    dataSaved = {
      ...dataSaved,
      title: value[0].Title,
      description: value[0].Description,
      // head_title: value[0].head_title,
      // category: value[0].dados_noticia?.[0].categoria,
      subtitle: value[0].head_title,
    };
  }

  onChangeBlock(block, dataSaved);
};
